import { NsPalette } from "./ns-eds-types";

export const palette: NsPalette = {
  yellow900: "#6A5618",
  yellow800: "#8C7321",
  yellow700: "#B69016",
  yellow600: "#DA9D00",
  yellow500: "#FFC70F",
  yellow400: "#FED652",
  yellow300: "#FFE180",
  yellow200: "#FFEBA8",
  yellow100: "#FFF2C8",
  yellow50: "#FBF7DB",
  blue900: "#1F2C42",
  blue800: "#1B3460",
  blue700: "#0A3680",
  blue600: "#0C44A1",
  blue500: "#0062D1",
  blue400: "#5D9FEA",
  blue300: "#5D9FEA",
  blue200: "#C4DBF7",
  blue100: "#DBEAFF",
  blue50: "#EBF5FF",
  teal900: "#082E3A",
  teal800: "#082E3A",
  teal700: "#17586D",
  teal600: "#236D86",
  teal500: "#2B87A6",
  teal400: "#33A0C4",
  teal300: "#56C3DE",
  teal200: "#8DD9EC",
  teal100: "#B3E9F4",
  teal50: "#D4F6FC",
  green900: "#103328",
  green800: "#244C40",
  green700: "#2F6656",
  green600: "#3E7F67",
  green500: "#3E9D7B",
  green400: "#47BD99",
  green300: "#4ECDA6",
  green200: "#9AE0C4",
  green100: "#B9F4DB",
  green50: "#DAFBF0",
  red900: "#81031A",
  red800: "#9A041F",
  red700: "#B30525",
  red600: "#CE092D",
  red500: "#EB0F38",
  red400: "#F06666",
  red300: "#FF9496",
  red200: "#FFBDBE",
  red100: "#FADCDD",
  red50: "#FCEAEB",
  orange900: "#49250E",
  orange800: "#6A3718",
  orange700: "#A03F02",
  orange600: "#CA4F02",
  orange500: "#F05C00",
  orange400: "#FF9544",
  orange300: "#FFBB7A",
  orange200: "#F7D7B2",
  orange100: "#F7E9D4",
  orange50: "#FBF1E7",
  purple900: "#33224E",
  purple800: "#472F6F",
  purple700: "#6139A2",
  purple600: "#7547C2",
  purple500: "#885DD0",
  purple400: "#A880EF",
  purple300: "#C9ACF8",
  purple200: "#E0CCFF",
  purple100: "#EBDEFD",
  purple50: "#F8ECFE",
  pink900: "#632142",
  pink800: "#84244B",
  pink700: "#A12662",
  pink600: "#BE2771",
  pink500: "#D53483",
  pink400: "#EA66AA",
  pink300: "#F6A2CF",
  pink200: "#FAC7E4",
  pink100: "#FFDBF0",
  pink50: "#FBE9F3",
  black: "#000000",
  gray950: "#0D0E10",
  gray900: "#191A1C",
  gray800: "#252528",
  gray700: "#333438",
  gray600: "#4D4E51",
  gray500: "#75767C",
  gray400: "#93949A",
  gray300: "#C4C5CB",
  gray200: "#D6D7DC",
  gray100: "#E4E5E8",
  gray75: "#EAEBEE",
  gray50: "#F0F1F3",
  white: "#FFFFFF",
  alphaBlack900: "#040409E8",
  alphaBlack800: "#040409DE",
  alphaBlack700: "#040409CF",
  alphaBlack600: "#040409B5",
  alphaBlack500: "#00010D8C",
  alphaBlack400: "#00010D6B",
  alphaBlack300: "#00021B3A",
  alphaBlack200: "#00021B29",
  alphaBlack100: "#060F2E1C",
  alphaBlack75: "#060F2E14",
  alphaBlack50: "#060F2E0F",
  alphaWhite900: "#FFFFFFE8",
  alphaWhite800: "#FFFFFFDE",
  alphaWhite700: "#FFFFFFCF",
  alphaWhite600: "#FFFFFFB5",
  alphaWhite500: "#FFFFFF91",
  alphaWhite400: "#FFFFFF6B",
  alphaWhite300: "#FFFFFF51",
  alphaWhite200: "#FFFFFF3A",
  alphaWhite100: "#FFFFFF29",
  alphaWhite75: "#FFFFFF1C",
  alphaWhite50: "#FFFFFF14",
  transparent: "#00000000",
};
